import React from 'react';
import { ACTIVE_THEME, getThemeVars } from '../themes/dashboardThemes';
import DashboardSidebar from '../components/DashboardSidebar';
import GoMessages from './GoMessages';

const GoMessagesNew = () => {
  const theme = getThemeVars(ACTIVE_THEME);

  return (
    <div
      className="dashboard-new font-body selection:bg-primary-container selection:text-on-primary-container h-[100dvh] overflow-hidden flex flex-col tablet-sm:flex-row"
      style={{ ...theme, backgroundColor: 'var(--chrome-bg)', color: 'var(--chrome-text)' }}
    >
      <DashboardSidebar activePath="/messages" />
      <main className="flex-1 h-[100dvh] overflow-hidden hide-scrollbar cm-pb-mobile-nav flex flex-col">
        <GoMessages />
      </main>
    </div>
  );
};

export default GoMessagesNew;
